export default [
    {
        path: '/patient-survey',
        name: 'patient-review',
        view: 'referrals/tracking/PatientReview',
        middlewares: [],
    },
]
